import { AgenciesEP } from './AgenciesEP';
import { AppCustomDataEP } from './AppCustomDataEP'
import { BookingEngineEP } from './BookingEngineEP';
import { BookingsEP } from './BookingsEP';
import { CompaniesEP } from './CompaniesEP';
import {ContactEP} from './ContactEP';
import { ErrorNotificationsEP } from './ErrorNotificationsEP';
import { HotelsEP } from './HotelsEP';
import { NewsEP } from './NewsEP';
import { OrganizationEP } from './OrganizationEP';
import { PaymentsConfigurationEP } from './PaymentConfigurationEP';
import { RegimesEP } from './RegimesEP';
import { UsersEP } from './UsersEP';
import { CountriesEP } from './CountriesEP';
import { TPVEP } from './TPVEP';
import { ConfigurationEP } from './ConfigurationEP';
import { AccountsEP  } from './AccountsEP';

export const RegisterEndPoints = []
    .concat(AgenciesEP)
    .concat(AppCustomDataEP)
    .concat(BookingEngineEP)
    .concat(BookingsEP)
    .concat(CompaniesEP)
    .concat(ContactEP)
    .concat(ErrorNotificationsEP)
    .concat(HotelsEP)
    .concat(OrganizationEP)
    .concat(RegimesEP)
    .concat(UsersEP)
    .concat(NewsEP)
    .concat(PaymentsConfigurationEP)
    .concat(TPVEP)
    .concat(ConfigurationEP)
    .concat(CountriesEP)
    .concat(AccountsEP)
    ;
